<sbnb-content-header
  [saveButtonShown]="false"
  [sticky]="false"
  [navigateBack]="false"
  novaContentId="property-detail-direct"></sbnb-content-header>

<!-- Not onboarded to Direct, show the pitch -->
<section *ngIf="!(isDirectOnboarded$ | async); else isOnboarded">
  <ng-template [ngTemplateOutlet]="pitchDirect"></ng-template>
</section>

<ng-template #isOnboarded>
  <ng-template [ngTemplateOutlet]="activeSitesWidgets"></ng-template>
  <ng-template [ngTemplateOutlet]="payoutMethodTemplate"></ng-template>
  <ng-template [ngTemplateOutlet]="cancellationPolicyTemplate"></ng-template>
  <ng-template [ngTemplateOutlet]="promoCodesTemplate"></ng-template>
  <ng-template [ngTemplateOutlet]="taxesTemplate"></ng-template>
</ng-template>

<ng-template #activeSitesWidgets>
  <div class="active-sites-widgets">
    <div fxLayout fxLayoutAlign="start center" fxLayoutGap="24px">
      <h3>Sites</h3>
      <sbnb-button [routerLink]="['/direct']" type="secondary" size="mini">Manage</sbnb-button>
    </div>

    <mat-spinner *ngIf="loadingSites" [diameter]="24"></mat-spinner>

    <div *ngIf="!loadingSites" class="site-widget-container">
      <div *ngIf="propertySites.length === 0; else propertySitesTemplate">
        This property is not yet listed on any Direct sites.
      </div>

      <ng-template #propertySitesTemplate>
        <div class="flex flex-col">
          <ng-container *ngFor="let site of propertySites">
            <div *ngIf="site.url" class="flex items-center px-3 py-4 border-t border-smoke">
              <a [href]="site.url" target="_blank" class="hover:underline mr-4 inline-flex">{{ site.url }}</a>
              <div class="hidden sm:block cursor-pointer">
                <mat-icon [matTooltip]="'Copy Property URL to clipboard'" (click)="copyPropertyURL(site)">
                  content_copy
                </mat-icon>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-template>
    </div>
  </div>
</ng-template>

<ng-template #promoCodesTemplate>
  <div class="promo-codes">
    <div fxLayout fxLayoutAlign="start center" fxLayoutGap="24px">
      <h3>Active promo codes</h3>
      <sbnb-button [routerLink]="['/direct/promotions']" type="secondary" size="mini">Manage</sbnb-button>
    </div>

    <mat-spinner *ngIf="loadingPromoCodes" [diameter]="24"></mat-spinner>

    <div *ngIf="!loadingPromoCodes" class="promoCode-container">
      <div *ngIf="promoCodes.length === 0">No active promo codes for this property.</div>
      <div *ngIf="promoCodes.length > 0" fxLayout="row wrap" fxLayoutAlign="start center" fxLayoutGap="8px">
        <div *ngFor="let code of promoCodes" class="code-pill" (click)="copyPromoCode(code)">{{ code }}</div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #taxesTemplate>
  <div *ngIf="isPremium$ | async" class="taxes">
    <h3>Taxes</h3>

    <mat-spinner *ngIf="loadingTaxes" [diameter]="24"></mat-spinner>

    <ng-container *ngIf="!loadingTaxes">
      <div *ngIf="taxes.length === 0" style="margin-top: 12px">No tax data for this property.</div>

      <table *ngIf="taxes?.length > 0" mat-table [dataSource]="taxes">
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef>Name</th>
          <td mat-cell *matCellDef="let element">{{ element.name }}</td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>Type</th>
          <td mat-cell *matCellDef="let element">{{ element.type }}</td>
        </ng-container>

        <ng-container matColumnDef="amount">
          <th class="header-align-right" mat-header-cell *matHeaderCellDef>Amount</th>
          <td class="header-align-right" mat-cell *matCellDef="let element">{{ element.amount | number: '1.2-2' }}%</td>
        </ng-container>

        <ng-container matColumnDef="appliesTo">
          <th mat-header-cell *matHeaderCellDef>Applies to</th>
          <td mat-cell *matCellDef="let element">
            {{ element.appliesTo.join(', ') }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="['name', 'type', 'amount', 'appliesTo']"></tr>
        <tr mat-row *matRowDef="let row; columns: ['name', 'type', 'amount', 'appliesTo']"></tr>
      </table>
    </ng-container>
  </div>
</ng-template>

<ng-template #payoutMethodTemplate>
  <div *ngIf="(isPremium$ | async) || (isBasic$ | async)" class="payout-methods">
    <div fxLayout fxLayoutAlign="start center" fxLayoutGap="24px">
      <h3>Payout method</h3>
      <sbnb-button [routerLink]="['/direct/payouts']" type="secondary" size="mini">Manage</sbnb-button>
    </div>

    <mat-spinner *ngIf="loadingPayoutMethods" [diameter]="24"></mat-spinner>

    <div *ngIf="!loadingPayoutMethods" class="payout-methods-container" fxLayoutAlign="start center" fxLayoutGap="16px">
      <ng-container *ngIf="payoutMethods?.length > 0">
        <mat-form-field class="payout-method-select">
          <mat-select
            [(ngModel)]="activePayoutMethod"
            (selectionChange)="updatePayoutMethod(propertyId, activePayoutMethod.uuid)">
            <mat-option *ngFor="let payout of payoutMethods" [value]="payout">
              {{ payout.name ? payout.name : payout.adyen?.legal_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-spinner *ngIf="savingPayoutMethod" [diameter]="24"></mat-spinner>

        <div *ngIf="recentlySavedPayoutMethod" fxLayout fxLayoutAlign="start center">
          <mat-icon class="grass-darker">check</mat-icon>
          <span class="grass-darker">Saved</span>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #cancellationPolicyTemplate>
  <div class="cancellation-policies">
    <div fxLayout fxLayoutAlign="start center" fxLayoutGap="24px">
      <h3>Cancellation policy</h3>
      <sbnb-button [routerLink]="['/direct/cancellation-policies']" type="secondary" size="mini">Manage</sbnb-button>
    </div>

    <mat-spinner *ngIf="loadingCancellationPolicies" [diameter]="24"></mat-spinner>

    <div *ngIf="!loadingCancellationPolicies" class="cancellation-policies-container">
      <div *ngIf="cancellationPolicies.length === 0" style="margin-top: 12px">
        No cancellation policy data for this property.
      </div>

      <ng-container *ngIf="cancellationPolicies?.length > 0">
        <mat-form-field class="cancellation-policy-select">
          <mat-select disabled [(ngModel)]="activeCancellationPolicy">
            <mat-option *ngFor="let policy of cancellationPolicies" [value]="policy">{{ policy.name }}</mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #pitchDirect>
  <div class="not-onboarded-to-direct" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="26px">
    <h3>You don't have an active Direct plan</h3>
    <p>
      Check out Direct to create your own website tailored to short-term rental bookings that capture payments and syncs
      automatically with all your other channels.
    </p>

    <sbnb-button [routerLink]="['/direct']">Get started with Direct</sbnb-button>
  </div>
</ng-template>
